import React from 'react';
import clsx from 'clsx';

/**
 * Пропсы для компонента LoadingSpinner
 */
interface LoadingSpinnerProps {
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
  text?: string;
}

/**
 * Компонент индикатора загрузки
 * Использует DaisyUI loading компонент с настраиваемыми размерами
 * @param size - Размер спиннера
 * @param className - Дополнительные CSS классы
 * @param text - Текст для отображения рядом со спиннером
 * @returns JSX элемент
 */
export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  className,
  text
}) => {
  const spinnerClasses = clsx(
    'loading loading-spinner',
    {
      'loading-xs': size === 'xs',
      'loading-sm': size === 'sm',
      'loading-md': size === 'md',
      'loading-lg': size === 'lg'
    },
    className
  );

  if (text) {
    return (
      <div className="flex items-center gap-3">
        <span className={spinnerClasses}></span>
        <span className="text-base-content/70">{text}</span>
      </div>
    );
  }

  return <span className={spinnerClasses}></span>;
};
